module.exports = __webpack_public_path__ + "img/car_sendai19.edc7ce45.jpg";